'use client';
import { styled } from '@mui/material/styles';

import { Slider } from '@mui/material';

export const Baserangeslider = styled(Slider)();
